<section class="cmn-innerpage-wrapper">
  <ng-container *ngIf="!loading && !noData">
    <div *appHasPermission="'VIEW_DASHBOARD'" class="inner-content dashboard">
      <div class="head">
        <div class="left-set">
          <h2 class="cmn-inner-heading">Welcome back!</h2>
          <p>Let's create something amazing today!</p>
        </div>
        <div class="right-set-wrapper"></div>
      </div>
      <div class="project-dashboard-wrapper">
        <div class="dashboard-card-wrapper-grid">
          <app-card
            title="Stories"
            [count]="dashboardData?.totalStories"
            subTitle=""
            [subCount]=""
            link="/stories"
            addLink="/stories/new"
            colorClass="dashboard-color-one"
            textColorClass="dash-txt-color-one"
            addPermission="ADD_STORY"
            viewPermission="VIEW_STORY"
          >
            <svg
              icon
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              >
              <path
                d="M8.3551 -0.00019598C8.23229 0.0180665 8.115 0.0631323 8.01156 0.131804C8.01156 0.131804 6.94117 0.805342 5.79041 1.53388C4.63964 2.26157 3.35941 3.06373 3.06664 3.22619L3.01333 3.25157C1.95056 3.90734 1.72971 4.97857 1.69164 5.57934C1.6891 5.60727 1.69164 5.63011 1.69164 5.65973C1.68233 5.8848 1.69164 6.0295 1.69164 6.0295V17.0828C1.69164 18.6888 3.56418 19.4613 5.3411 19.4613C5.93341 19.4613 6.52571 19.3657 7.03341 19.1965C7.37187 19.0273 7.61471 18.6888 7.61471 18.3503V9.46573C7.61471 7.51957 8.03779 6.60573 9.30702 5.84419C9.64548 5.67496 13.1943 3.22534 13.1943 3.22534C13.3635 3.05611 13.5378 2.71257 13.5378 2.45873V2.37919C13.5378 2.04073 13.3686 1.7818 13.1147 1.61257C12.8609 1.44334 12.5224 1.44334 12.2686 1.61257C12.1839 1.69719 7.02241 5.17234 5.92241 5.76465C4.82241 6.44157 3.79602 6.60488 3.54217 6.26642C3.46348 6.18773 3.39494 5.94657 3.38394 5.71134V5.65803C3.38479 5.42788 3.44402 4.99465 3.91279 4.70611C4.38833 4.44127 5.56871 3.68734 6.7161 2.96134C7.20094 2.65419 7.26102 2.62119 7.64094 2.37919C7.69096 2.5859 7.81698 2.7662 7.99392 2.88419C8.17086 3.00218 8.38574 3.04922 8.59579 3.01593C8.80585 2.98265 8.99567 2.87149 9.12746 2.70457C9.25926 2.53766 9.32336 2.32723 9.30702 2.11519V0.845958C9.30797 0.725351 9.28312 0.605936 9.23414 0.495717C9.18517 0.385499 9.11319 0.287024 9.02305 0.206895C8.9329 0.126766 8.82667 0.0668337 8.71147 0.031117C8.59627 -0.00459976 8.47476 -0.015276 8.3551 -0.00019598ZM15.1243 2.96134C14.9898 2.98372 14.8626 3.0383 14.7537 3.12042C14.7537 3.12042 10.4942 5.98634 9.75633 6.47796L9.7301 6.50504C9.11748 6.9645 8.75448 7.51111 8.59287 8.01119C8.50282 8.29342 8.45827 8.58818 8.46087 8.88442V9.14927C8.45965 9.17548 8.45965 9.20174 8.46087 9.22796V19.4613C8.46087 21.069 10.3123 21.9998 12.0046 21.9998C12.7661 21.9998 13.4532 21.8357 13.9609 21.4972C14.9763 20.9049 19.8839 17.082 19.8839 17.082C20.1378 16.9127 20.307 16.6741 20.307 16.4203V5.42027C20.307 4.99719 20.1429 4.74334 19.8044 4.57411C19.5506 4.40488 19.1334 4.48442 18.8796 4.65365C17.5257 5.66903 13.8813 8.5358 13.0352 9.0435C11.8506 9.72042 10.7345 9.88965 10.3114 9.46657C10.1422 9.29734 10.1532 9.13827 10.1532 8.88442C10.1577 8.73775 10.1755 8.61421 10.2065 8.5138C10.2539 8.36657 10.3503 8.1855 10.7083 7.90627C10.7252 7.89273 10.7167 7.89357 10.7345 7.88003C11.3463 7.47134 13.2171 6.19619 14.4373 5.36696C14.5064 5.55241 14.6383 5.70776 14.8101 5.80599C14.982 5.90422 15.1828 5.93912 15.3777 5.90461C15.5725 5.8701 15.7492 5.76837 15.8768 5.61711C16.0044 5.46585 16.075 5.27464 16.0763 5.07673V3.8075C16.0772 3.68689 16.0523 3.56747 16.0034 3.45726C15.9544 3.34704 15.8824 3.24856 15.7923 3.16843C15.7021 3.0883 15.5959 3.02837 15.4807 2.99266C15.3655 2.95694 15.244 2.94626 15.1243 2.96134ZM18.6147 9.14927V10.8416L14.3839 14.1196V12.4273L18.6147 9.14927Z"
                fill="black"
              />
            </svg>
          </app-card>
          <app-card
            title="Video stories"
            [count]="dashboardData?.totalVideoStories"
            subTitle=""
            [subCount]=""
            link="/video"
            addLink="/video/new"
            colorClass="dashboard-color-one"
            textColorClass="dash-txt-color-one"
            addPermission="ADD_VIDEO_STORY"
            viewPermission="VIEW_VIDEO_STORY"
          >
            <svg
              icon
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              >
              <path
                d="M4.68262 6.04297H1.6709V7.29297H18.3359V15C18.3359 16.8408 16.8437 18.3338 15.0029 18.334H5.00293C3.16198 18.334 1.66992 16.8409 1.66992 15V5C1.67027 3.15935 3.1622 1.66699 5.00293 1.66699H7.80859L4.68262 6.04297ZM10.2783 10.4629C9.44764 9.90929 8.33496 10.5046 8.33496 11.5029V13.498C8.33496 14.4963 9.44764 15.0917 10.2783 14.5381L11.7754 13.541C12.5176 13.0462 12.5176 11.9547 11.7754 11.46L10.2783 10.4629ZM11.3496 6.04297H6.21973L9.34473 1.66699H14.4746L11.3496 6.04297ZM15.9189 1.7959C17.3141 2.19408 18.3359 3.47799 18.3359 5.00098V6.04297H12.8857L15.9189 1.7959Z"
                fill="black"
              />
            </svg>
          </app-card>
          <app-card
            title="Posters"
            [count]="dashboardData?.totalPosters"
            subTitle=""
            [subCount]=""
            link="/poster"
            addLink="/poster/new"
            colorClass="dashboard-color-one"
            textColorClass="dash-txt-color-one"
            addPermission="ADD_POSTER"
            viewPermission="VIEW_POSTER"
          >
            <svg
              icon
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              >
              <path
                d="M3.25065 18.5832C2.65482 18.5832 2.14493 18.3712 1.72098 17.9473C1.29704 17.5233 1.08471 17.0131 1.08398 16.4165V5.58317C1.08398 4.98734 1.29632 4.47745 1.72098 4.05351C2.14565 3.62956 2.65554 3.41723 3.25065 3.41651H14.084C14.6798 3.41651 15.1901 3.62884 15.6147 4.05351C16.0394 4.47817 16.2514 4.98806 16.2507 5.58317V16.4165C16.2507 17.0123 16.0387 17.5226 15.6147 17.9473C15.1908 18.3719 14.6805 18.5839 14.084 18.5832H3.25065ZM8.12565 13.1665L7.04232 11.7311C6.93398 11.5866 6.78954 11.5191 6.60898 11.5285C6.42843 11.5379 6.28398 11.6145 6.17565 11.7582L4.9569 13.3832C4.81246 13.5637 4.79873 13.7533 4.91573 13.9519C5.03273 14.1505 5.19993 14.2498 5.41732 14.2498H11.9173C12.134 14.2498 12.2965 14.1505 12.4048 13.9519C12.5131 13.7533 12.4951 13.5637 12.3506 13.3832L10.6173 11.0269C10.509 10.8825 10.3645 10.8103 10.184 10.8103C10.0034 10.8103 9.85898 10.8825 9.75065 11.0269L8.12565 13.1665ZM19.5007 18.5832C19.1937 18.5832 18.9366 18.4792 18.7293 18.2712C18.522 18.0632 18.418 17.8061 18.4173 17.4998V4.49984C18.4173 4.1929 18.5213 3.93579 18.7293 3.72851C18.9373 3.52123 19.1944 3.41723 19.5007 3.41651C19.8069 3.41579 20.0643 3.51979 20.2731 3.72851C20.4818 3.93723 20.5854 4.19434 20.584 4.49984V17.4998C20.584 17.8068 20.48 18.0643 20.272 18.2723C20.064 18.4803 19.8069 18.5839 19.5007 18.5832Z"
                fill="black"
              />
            </svg>
          </app-card>
          <app-card
            title="App users"
            [count]="dashboardData?.totalAppUsers"
            subTitle=""
            [subCount]=""
            link="/users"
            addLink=""
            colorClass="dashboard-color-one"
            textColorClass="dash-txt-color-one"
            addPermission="ADD_USER"
            viewPermission="VIEW_USER"
          >
            <svg
              icon
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              >
              <path
                d="M10 13C13.866 13 17 14.7909 17 17C17 19.2091 13.866 21 10 21C6.13401 21 3 19.2091 3 17C3 14.7909 6.13401 13 10 13ZM15.8867 13.0322C18.7799 13.2465 21 14.4938 21 16C21 17.0776 19.8635 18.0228 18.1572 18.5518C18.3804 18.0597 18.5 17.5388 18.5 17C18.5 15.4409 17.4974 14.0331 15.8867 13.0322ZM10 3C12.2091 3 14 4.79086 14 7C14 9.20914 12.2091 11 10 11C7.79086 11 6 9.20914 6 7C6 4.79086 7.79086 3 10 3ZM15.126 5.00293C16.7243 5.06904 18 6.38544 18 8C18 9.65683 16.6568 11 15 11C14.6351 11 14.2854 10.9347 13.9619 10.8154C14.9145 9.82651 15.5 8.48151 15.5 7C15.5 6.2955 15.3674 5.62201 15.126 5.00293Z"
                fill="black"
              />
            </svg>
          </app-card>
          <app-card
            title="Portal users"
            [count]="dashboardData?.totalAdminUsers"
            link="/users"
            addLink=""
            colorClass="dashboard-color-one"
            textColorClass="dash-txt-color-one"
            addPermission="ADD_USER"
            viewPermission="VIEW_USER"
          >
            <svg
              icon
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5 10.125C11.9497 10.125 13.125 8.94975 13.125 7.5C13.125 6.05025 11.9497 4.875 10.5 4.875C9.05025 4.875 7.875 6.05025 7.875 7.5C7.875 8.94975 9.05025 10.125 10.5 10.125ZM10.5 17.125C13.3995 17.125 15.75 15.9497 15.75 14.5C15.75 13.0503 13.3995 11.875 10.5 11.875C7.6005 11.875 5.25 13.0503 5.25 14.5C5.25 15.9497 7.6005 17.125 10.5 17.125ZM5.58395 11.8921C3.42299 12.0254 1.75 12.9465 1.75 14.063C1.75 14.9835 2.88705 15.7712 4.49718 16.0941C4.13738 15.6069 3.9375 15.0677 3.9375 14.5005C3.9375 13.5 4.55942 12.5867 5.58395 11.8921ZM17.0626 14.5005C17.0626 15.0677 16.8627 15.6069 16.5029 16.0941C18.113 15.7712 19.2501 14.9835 19.2501 14.063C19.2501 12.9465 17.5771 12.0254 15.4161 11.8921C16.4406 12.5867 17.0626 13.5 17.0626 14.5005ZM13.7535 9.71847C14.1851 9.08673 14.4375 8.32284 14.4375 7.5C14.4375 7.22695 14.4097 6.96039 14.3568 6.703C14.5205 6.6523 14.6946 6.625 14.875 6.625C15.8415 6.625 16.625 7.4085 16.625 8.375C16.625 9.3415 15.8415 10.125 14.875 10.125C14.4482 10.125 14.0572 9.97226 13.7535 9.71847ZM6.125 6.625C6.30541 6.625 6.47945 6.6523 6.64321 6.703C6.59029 6.96039 6.5625 7.22695 6.5625 7.5C6.5625 8.32284 6.8149 9.08673 7.24649 9.71847C6.9428 9.97226 6.55174 10.125 6.125 10.125C5.1585 10.125 4.375 9.3415 4.375 8.375C4.375 7.4085 5.1585 6.625 6.125 6.625Z"
                fill="black"
              />
            </svg>
          </app-card>
          <app-card
            title="Badges"
            [count]="dashboardData?.totalBadges"
            link="/badge"
            addLink="/badge/new"
            colorClass="dashboard-color-one"
            textColorClass="dash-txt-color-one"
            addPermission="ADD_BADGE"
            viewPermission="VIEW_BADGE"
          >
            <svg
              icon
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
            >
              >
              <path
                d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM15.08 16L12 14.15L8.93 16L9.74 12.5L7.03 10.16L10.61 9.85L12 6.55L13.39 9.84L16.97 10.15L14.26 12.5L15.08 16Z"
                fill="black"
              />
            </svg>
          </app-card>
        </div>
      </div>
    </div>
  </ng-container>
  <div *ngIf="!isPermission" class="no-permissions">
    <div class="img-div">
      <img src="../../../assets/images/icons/cross-icon.svg" alt="" />
    </div>
    <div class="text-div">
      <h4>You do not have permission to view this content.</h4>
      <p>Please contact your administrator for any assistance.</p>
    </div>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
  <div *ngIf="noData">
    <app-no-data-component></app-no-data-component>
  </div>
</section>
